var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"CardLayout"}},[_c('div',{staticClass:"cards-relatorios"},[_vm._m(0),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h6',[_vm._t("type")],2),_c('h2',[_vm._t("title")],2)]),_c('div',{staticClass:"card-footer"},[_vm._t("button")],2)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-icon"},[_c('i',{staticClass:"fa fa-bar-chart"})])
}]

export { render, staticRenderFns }